module.exports = __webpack_public_path__ + "img/99.5d541fc5.jpg";